import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import {
  HuntPackageRecord,
  ThreatProfile,
} from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

@Injectable({
  providedIn: 'root',
})
export class ThreatProfileService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  public getThreatProfilebyThreatName = (
    huntPackage: HuntPackageRecord,
  ): Observable<Array<ThreatProfile>> => {
    // The API returns the { total, results } wrapper (CyborgThreatProfileQueryResultDto).
    // Unwrap to `results` here so callers keep receiving a bare array.
    return this.httpClient
      .get<{
        total: number
        results: Array<ThreatProfile>
      }>(
        `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/query?term=${huntPackage.context.threat_names}`,
      )
      .pipe(map((response) => response.results))
  }

  public getThreatProfileByUUID = (uuid: string): Observable<ThreatProfile> => {
    return this.httpClient.get<ThreatProfile>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/${uuid}`,
    )
  }

  public getThreatProfilesbyUUIDs(
    uuids: Array<string>,
  ): Observable<Array<ThreatProfile>> {
    const searchParams: { [param: string]: string | string[] } = { uuids }
    return this.httpClient.get<Array<ThreatProfile>>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/list/`,
      {
        params: searchParams,
      },
    )
  }
}
